export var getAuthInfoFromLoginToken = function (loginToken) { return ({
    accessToken: loginToken.access_token,
    idToken: loginToken.id_token,
    state: loginToken.state,
    expiresIn: Number(loginToken.expires_in),
    tokenType: loginToken.token_type,
    scope: loginToken.scope,
}); };
//# sourceMappingURL=getAuthInfoFromLoginToken.js.map